import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./card_slide.css";

const TextSlide = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    appendDots: (dots) => (
      <div
        style={{
          // backgroundColor: "black",
          borderRadius: "10px",
          padding: "10px",
        }}
        className="absolute top-0"
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrows: true,
          centerMode: true,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          cssEase: "linear",
        },
      },
    ],
  };

  const SlideData = [
    {
      id: 1,
      title:
        "No. 10/B, Kan Bawza Street, Golden Valley 1, Bahan Township, Yangon, Myanmar",
      // title_span: "start Here",
      // desc: "The newest luxury wellness spa experience in Yangon for your inner peace and outer beauty.",
      // img: banner1,
    },
    {
      id: 2,
      title: "Member benefit",
      // title_span: "start Here",
      // desc: "The newest luxury wellness spa experience in Yangon for your inner peace and outer beauty.",
      // img: banner2,
    },
  ];

  return (
    <div className="overflow-x-hidden overflow-y-hidden h-14">
      <Slider {...settings}>
        {SlideData?.map((item) => (
          //
          <div key={item.id} className=" text-center pt-1 ">
            {item.title}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TextSlide;
